export const getEkycHeaders = (extra = {}) => {
  const token = sessionStorage.getItem("ekycSessionToken");
  const headers = { ...extra };
  if (token) {
    headers["X-EKYC-Token"] = token;
  }
  return headers;
};
